export const FAKE_SOLD_GROUP_ID = 'fakeSoldGroupId';
